import { motion } from "framer-motion";
import { useLanguage } from "@/i18n";

const Chapters = () => {
  const { t } = useLanguage();
  return (
    <section id="capitoli" data-testid="chapters-section" className="py-20 lg:py-32 px-6 sm:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto flex flex-col gap-24 lg:gap-36">
        {t.chapters.map((c, i) => (
          <motion.div
            key={c.num}
            data-testid={`chapter-${c.num}`}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className={`grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12 items-center ${
              i % 2 === 1 ? "md:[direction:rtl]" : ""
            }`}
          >
            <div className={`md:col-span-7 [direction:ltr] ${i % 2 === 1 ? "md:pl-10" : ""}`}>
              <p className="font-display text-outline text-7xl sm:text-8xl leading-none select-none">{c.num}</p>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0D253A] mt-4">{c.title}</h2>
              <p className="mt-6 text-base sm:text-lg leading-relaxed text-[#333D47] max-w-lg">{c.text}</p>
            </div>
            <motion.div
              className="md:col-span-5 [direction:ltr]"
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.5 }}
            >
              <div className="img-frame overflow-hidden shadow-[0_30px_60px_-25px_rgba(13,37,58,0.35)]">
                <img src={c.img} alt={c.title} className="w-full h-72 sm:h-96 object-cover hover:scale-105 transition-transform duration-700" />
              </div>
            </motion.div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Chapters;
